// translations.js - Button label translations for Cypher Arena

const translations = {
  en: {
    // Control panel related
    openControlPanel: "Open Control Panel",
    enterFullScreen: "Enter Full Screen",
    back: "Back",
    
    // Timer related
    timer: "Timer",
    interval: "Interval",
    roundDuration: "Round Duration",
    roundTime: "Round Time",
    roundDurationValue: "{{value}}s",
    adjust: "adjust",
    
    // Control buttons
    nextItem: "Next Item",
    decreaseInterval: "Decrease Interval",
    increaseInterval: "Increase Interval",
    pause: "Pause",
    resume: "Resume",
    resetRound: "Reset Round",
    
    // Home page
    freestyleHub: "Ultimate Freestyle Sanctuary",
    freestyleRounds: "Freestyle Rounds",
    wordMode: "Word Mode",
    imagesMode: "Images",
    contrastingMode: "Rap Avatar Duel",
    topicMode: "Topic Generator",
    giveFeedback: "Give Feedback!",
    settings: "Settings",
    beats: "Beats",
    spotifyLoginNote: "Note: You'll need to allow third-party cookies in your browser settings and be logged into Spotify to play full tracks. Otherwise, only 30-second previews will be available.",
    openInSpotify: "Open in Spotify",

    // Beats Mode
    beatsModeTitle: "Freestyle Beats",
    beatsModeDescription: "Use these beats for your freestyle practice sessions.",
    thirdPartyCookiesWarning: "Note: You'll need to allow third-party cookies in your browser settings and be logged into Spotify to play full tracks. Otherwise, only 30-second previews will be available.",
    
    // Exit fullscreen
    exitFullScreen: "Exit Full Screen",
    
    // Feedback page
    reportFeedback: "Report Feedback",
    nickname: "Nickname (max 100 characters):",
    feedbackText: "Feedback (max 2000 characters):",
    submitFeedback: "Submit Feedback",
    feedbackSuccess: "Feedback submitted successfully!",
    feedbackError: "An error occurred. Please try again later.",
    
    // Settings page
    settingsPage: "Settings",
    imageSettings: "Image Settings",
    imagePreloadDescription: "Preload images to improve performance during battle mode. This can use a significant amount of storage space.",
    preloadImages: "Preload Images",
    preloading: "Preloading...",
    clearImageCache: "Clear Image Cache",
    preloadingProgress: "Preloading Progress",
    preloadComplete: "Preload Complete",
    imagesPreloadedSuccess: "Images have been successfully preloaded to your device."
  },
  pl: {
    // Control panel related
    openControlPanel: "Timer w Nowym Oknie",
    enterFullScreen: "Full Ekran",
    back: "Wróć",
    
    // Timer related
    timer: "Stoper",
    interval: "Interwał",
    roundDuration: "Czas Rundy",
    roundTime: "Czas Rundy",
    roundDurationValue: "{{value}}s",
    adjust: "reguluj",
    
    // Control buttons
    nextItem: "Następny Element",
    decreaseInterval: "Zmniejsz Interwał",
    increaseInterval: "Zwiększ Interwał",
    pause: "Pauza",
    resume: "Wznów",
    resetRound: "Resetuj Rundę",
    
    // Home page
    freestyleHub: "Świątynia Freestyle'u",
    freestyleRounds: "Rundy Freestyle",
    wordMode: "Tryb Słów",
    imagesMode: "Obrazki",
    contrastingMode: "Rap Avatar Duel",
    topicMode: "Temator",
    giveFeedback: "Daj Feedback!",
    settings: "Ustawienia",
    beats: "Beaty",
    spotifyLoginNote: "Uwaga: Aby odtwarzać pełne utwory, musisz zezwolić na pliki cookie stron trzecich w ustawieniach przeglądarki i być zalogowanym do Spotify. W przeciwnym razie dostępne będą tylko 30-sekundowe fragmenty.",
    openInSpotify: "Otwórz w Spotify",

    // Beats Mode
    beatsModeTitle: "Beaty Freestyle",
    beatsModeDescription: "Użyj tych beatów do swoich sesji freestyle.",
    thirdPartyCookiesWarning: "Uwaga: Aby odtwarzać pełne utwory, musisz zezwolić na pliki cookie stron trzecich w ustawieniach przeglądarki i być zalogowanym do Spotify. W przeciwnym razie dostępne będą tylko 30-sekundowe fragmenty.",
    
    // Exit fullscreen
    exitFullScreen: "Wyłącz Pełny Ekran",
    
    // Feedback page
    reportFeedback: "Wyślij Feedback na temat aplikacji, błędów, sugestii, pomysłów itp.",
    nickname: "Ksywa:",
    feedbackText: "Twoja opinia (maks. 2000 znaków):",
    submitFeedback: "Wyślij Opinię",
    feedbackSuccess: "Opinia wysłana pomyślnie!",
    feedbackError: "Wystąpił błąd. Spróbuj ponownie później.",
    
    // Settings page
    settingsPage: "Ustawienia",
    imageSettings: "Ustawienia Obrazów",
    imagePreloadDescription: "Wstępnie załaduj obrazy, aby poprawić wydajność podczas bitwy. Może to wykorzystać znaczną ilość miejsca na urządzeniu.",
    preloadImages: "Załaduj Obrazy",
    preloading: "Ładowanie...",
    clearImageCache: "Wyczyść Pamięć Podręczną",
    preloadingProgress: "Postęp Ładowania",
    preloadComplete: "Ładowanie Zakończone",
    imagesPreloadedSuccess: "Obrazy zostały pomyślnie załadowane do pamięci podręcznej urządzenia."
  }
};

export default translations;